import { useT } from "@/i18n/useT";

export function NoPermission() {
  const { t } = useT();
  return (
    <section
      data-testid="picks-no-permission"
      aria-labelledby="picks-no-permission-title"
      className="flex flex-1 items-center justify-center p-6"
    >
      <h2
        id="picks-no-permission-title"
        className="text-[15px] font-[500] text-[var(--muted)]"
      >
        {t("shell.noPermission.title")}
      </h2>
    </section>
  );
}
